<template>
  <div>
    <div id="home" class="three-banner-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container-fluid">
            <div class="row align-items-center">
              <!-- Texto -->
              <div class="col-lg-8">
                <div class="banner-content" style="margin-left: 30px;">
                  <h1 style="color:#000000; line-height: 1.1;">
                    Políticas y Condiciones de Plotix
                  </h1>
                  <p style="max-width: 780px;">
                    En Plotix, creemos en la transparencia, la confianza y el compromiso con cada cliente.
                    Aquí encontrarás toda la información sobre nuestras políticas de servicio, privacidad y garantías,
                    para que sepas exactamente cómo trabajamos y cómo protegemos tus datos y tus equipos.
                  </p>
                  <ul>
                    <li>
                      <a class="cmn-banner-btn" href="#service-multiple">
                        Ver políticas
                        <i class="bx bx-right-arrow-alt"></i>
                      </a>
                    </li>
                    <li>
                      <a class="cmn-banner-btn" href="/#contact-strip">
                        Contactar soporte
                        <i class="bx bx-right-arrow-alt"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Imagen a la derecha -->
              <div class="col-lg-4 text-center">
                <img
                  src="../../assets/img/resources/politicas.png"
                  alt="Plotix Banner"
                  style="max-width: 85%; border-radius: 12px; box-shadow: 0 6px 25px rgba(0,0,0,0.15);"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBannerPolicies",
};
</script>
